import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ContactStore } from 'app/core/stores/base.store';
import { AuthService } from 'app/auth/auth.service';
import { NotificationUtils } from 'app/core/utils';

@Component({
  selector: 'app-self-contact-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './self-contact-dialog.component.html',
  styleUrls: ['./self-contact-dialog.component.css']
})
export class SelfContactDialogComponent {
  contactForm: FormGroup;
  loading = false;
  
  private contactStore = inject(ContactStore);
  private authService = inject(AuthService);
  
  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<SelfContactDialogComponent>
  ) {
    this.contactForm = this.fb.group({
      user_id: [JSON.parse(localStorage.getItem('user_profile')).id],
      category: ['Self'], // Fixed as 'Self'
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      organization: [''],
    });
  }
  
  onSubmit() {
    if (this.contactForm.valid) {
      this.loading = true;
      const formValue = this.contactForm.value;
      
      // Create the self contact
      this.contactStore.create({
        entity: formValue,
        endpoint: 'contact'
      });
      
      // Wait for the contact creation to complete
      setTimeout(() => {
        // Find the newly created Self contact
        const contacts = this.contactStore.entities();
        const selfContact = contacts.find(contact => 
          contact.category === 'Self' && 
          contact.first_name === formValue.first_name && 
          contact.last_name === formValue.last_name
        );
        
        if (selfContact) {
          this.updateProfileWithSelfContact(selfContact.id);
        } else {
          this.loading = false;
          NotificationUtils.getInstance().showError('Failed to find created Self contact');
          this.dialogRef.close(false);
        }
      }, 1000); // Give the store time to update
    }
  }
  
  private updateProfileWithSelfContact(contactId: number) {
    // Get the current profile
    const profile = this.authService.getCurrentProfile();
    if (profile) {
      // Update the self property
      profile.self = contactId;
      
      // Update the profile on the server
      this.authService.updateProfile(profile).subscribe({
        next: () => {
          this.loading = false;
          this.dialogRef.close(true);
        },
        error: (err) => {
          this.loading = false;
          NotificationUtils.getInstance().showError('Failed to update profile with Self contact');
          console.error('Error updating profile:', err);
        }
      });
    } else {
      this.loading = false;
      NotificationUtils.getInstance().showError('Profile not found');
      this.dialogRef.close(false);
    }
  }
  
  onCancel() {
    this.dialogRef.close(false);
  }
}
